export default {
  'nav.mail': 'Пошта',
};
